/* eslint-disable no-unexpected-multiline */
import { Component } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { Sort } from "@angular/material/sort";
import { CompareHelper } from "../../../_helpers/compare.helper";
import { SelectionModel } from "@angular/cdk/collections";
import cloneDeepWith from "lodash-es/cloneDeepWith";
import * as moment from "moment";
import deepCastToInt from "../../../_helpers/deepCastToInt";
import { ConfirmActionModalComponent } from "../confirm-action-modal/confirm-action-modal/confirm-action-modal.component";
import { AlertService } from "@modules/alert";

@Component({
  selector: "app-items-list",
  template: "",
})
export class ItemsListComponent {
  protected dialog: MatDialog;
  protected alertService: AlertService;
  /**
   * Loading indicator
   */
  isLoadingGeneral: boolean;

  /**
   * Pagination
   */
  p: number;
  total: number;
  itemsPage: number;
  public perPageValues = [
    { key: 25, label: "GENERALS.RESULTS_PER_PAGE" },
    { key: 30, label: "GENERALS.RESULTS_PER_PAGE" },
    { key: 50, label: "GENERALS.RESULTS_PER_PAGE" },
    { key: 100, label: "GENERALS.RESULTS_PER_PAGE" },
  ];
  private _perPage = 25;

  public get perPage() {
    return this._perPage;
  }
  public set perPage(value) {
    this._perPage = value;
  }
  public defaultFilters = {
    invoice_issue_start_date: null,
    invoice_issue_end_date: null,
    invoice_due_start_date: null,
    invoice_due_end_date: null,
    invoice_payment_start_date: null,
    invoice_payment_end_date: null,
  };
  invoiceIssueDate;
  invoiceDueDate;
  invoicePaymentDate;

  /**
   * Sorting
   */
  my_sort: Sort;
  active: any;
  direction: any;

  /**
   * Search
   */
  search_text: string;

  /**
   * Filters
   */
  filters = { page: 1 };
  availableFilters;
  startDate;
  endDate;

  /**
   * Bulk actions
   */
  selection = new SelectionModel(true, []);
  actions: Array<any>;
  showBulkActions = false;

  /**
   * Data
   */
  request_call;
  items;

  /**
   * Status
   */
  selectedStatus;

  private compareHelper: CompareHelper = new CompareHelper();

  /**
   * Get items to list
   */
  public getItems(page: number = 1): void {
    throw new Error("This method is abstract");
  }

  /**
   * Refresh listing url
   */
  public navigateByUrl(page: number = 1): void {
    throw new Error("This method is abstract");
  }

  /**
   * The the service
   */
  protected getService() {
    throw new Error("This method is abstract");
  }

  /**
   * Generate parameters for the API call
   */
  protected getParams(page: number) {
    const params = this.filters;

    params["page"] = page;
    params["per_page"] = this.perPage;

    if (this.startDate && this.endDate) {
      params["start_date"] = this.formatDataParam(this.startDate);
      params["end_date"] = this.formatDataParam(this.endDate);
    }

    if (this.startDate === "null" && this.endDate === "null") {
      delete params["start_date"];
      delete params["end_date"];
    }

    if (this.invoiceIssueDate) {
      if (
        this.invoiceIssueDate.invoice_issue_start_date &&
        this.invoiceIssueDate.invoice_issue_end_date
      ) {
        params["invoice_issue_start_date"] = this.formatDataParam(
          this.invoiceIssueDate.invoice_issue_start_date
        );
        params["invoice_issue_end_date"] = this.formatDataParam(
          this.invoiceIssueDate.invoice_issue_end_date
        );
      }

      if (
        this.invoiceIssueDate.invoice_issue_start_date === "null" &&
        this.invoiceIssueDate.invoice_issue_end_date === "null"
      ) {
        delete params["invoice_issue_start_date"];
        delete params["invoice_issue_end_date"];
      }
    }

    if (this.invoiceDueDate) {
      if (
        this.invoiceDueDate.invoice_due_start_date &&
        this.invoiceDueDate.invoice_due_end_date
      ) {
        params["invoice_due_start_date"] = this.formatDataParam(
          this.invoiceDueDate.invoice_due_start_date
        );
        params["invoice_due_end_date"] = this.formatDataParam(
          this.invoiceDueDate.invoice_due_end_date
        );
      }

      if (
        this.invoiceDueDate.invoice_due_start_date === "null" &&
        this.invoiceDueDate.invoice_due_end_date === "null"
      ) {
        delete params["invoice_due_start_date"];
        delete params["invoice_due_end_date"];
      }
    }

    if (this.invoicePaymentDate) {
      if (
        this.invoicePaymentDate.invoice_payment_start_date &&
        this.invoicePaymentDate.invoice_payment_end_date
      ) {
        params["invoice_payment_start_date"] = this.formatDataParam(
          this.invoicePaymentDate.invoice_payment_start_date
        );
        params["invoice_payment_end_date"] = this.formatDataParam(
          this.invoicePaymentDate.invoice_payment_end_date
        );
      }

      if (
        this.invoicePaymentDate.invoice_payment_start_date === "null" &&
        this.invoicePaymentDate.invoice_payment_end_date === "null"
      ) {
        delete params["invoice_payment_start_date"];
        delete params["invoice_payment_end_date"];
      }
    }

    if (this.my_sort) {
      params["order"] = this.compareHelper.setOrder(this.my_sort);
      params["order_direction"] = this.compareHelper.setDirection(this.my_sort);
    }
    if (params["order"] === "" && params["order_direction"] === "") {
      delete params["order"];
      delete params["order_direction"];
    }

    if (this.search_text) {
      params["search_text"] = this.search_text;
    } else {
      delete params["search_text"];
    }

    if (!this.filters["search_fields"]) {
      params["search_fields"] = "";
    }

    if (this.selectedStatus) {
      params["status_id"] = this.selectedStatus;
    } else if (!this.filters["status_id"]) {
      delete params["status_id"];
    }

    return params;
  }

  /**
   * Clear filters
   */
  clearFilters() {
    this.selectedStatus = null;
    this.perPage = 25;
    this.filters = { page: 1 };
    this.search_text = null;
    this.startDate = null;
    this.endDate = null;
    if (this.invoiceIssueDate) {
      this.defaultFilters.invoice_issue_start_date = null;
      this.defaultFilters.invoice_issue_end_date = null;
      this.invoiceIssueDate.invoice_issue_start_date = null;
      this.invoiceIssueDate.invoice_issue_end_date = null;
    }
    if (this.invoiceDueDate) {
      this.defaultFilters.invoice_due_start_date = null;
      this.defaultFilters.invoice_due_end_date = null;
      this.invoiceDueDate.invoice_due_start_date = null;
      this.invoiceDueDate.invoice_due_end_date = null;
    }
    if (this.invoicePaymentDate) {
      this.defaultFilters.invoice_payment_start_date = null;
      this.defaultFilters.invoice_payment_end_date = null;
      this.invoicePaymentDate.invoice_payment_start_date = null;
      this.invoicePaymentDate.invoice_payment_end_date = null;
    }
  }

  /**
   * Process the API response
   */
  protected processResponse(data, keepSelection?) {
    this.items = data.result.items;
    this.isLoadingGeneral = false;
    this.p = data.result.currentPage;
    this.total = data.result.total;
    this.itemsPage = data.result.perPage;
    if ("filters" in data.result) {
      this.availableFilters = data.result.filters;
    }
    if (!keepSelection) {
      this.selection = new SelectionModel(true, []);
    }
    this.setBulkAction();
  }

  /**
   * Monitor query params for change in filters
   */
  protected watchQueryParams(query) {
    if (query && Object.keys(query).length > 0) {
      this.filters = cloneDeepWith(query, deepCastToInt);
    } else {
      this.clearFilters();
      this.filters = this.getParams(1);
    }
    if (this.filters["search_text"]) {
      this.search_text = this.filters["search_text"];
    }
    if (this.filters["per_page"]) {
      this.perPage = this.filters["per_page"];
    }
    if (this.filters["order"]) {
      this.active = this.filters["order"];
      this.direction = this.filters["order_direction"];
    } else {
      this.active = "";
      this.direction = "";
    }

    this.getItems(this.filters.page);
  }

  /**
   * Apply date filter
   */
  setDate(e, returnValue?) {
    if (returnValue === "clearFilterDate") {
      return e;
    } else {
      if (e.start_date && e.end_date) {
        this.startDate = e.start_date;
        this.endDate = e.end_date;

        if (returnValue) {
          return {
            start_date: this.startDate,
            end_date: this.endDate,
          };
        } else {
          this.getItems();
        }
      }
    }
  }

  /**
   * Apply sort
   */
  sortData(sort: Sort) {
    this.my_sort = sort;
    this.navigateByUrl();
  }

  /** Whether the number of selected elements matches the total number of rows. */
  isAllSelected() {
    const numSelected = this.selection.selected.length;
    const numRows = this.items.length;
    return numSelected === numRows;
  }

  /** Selects all rows if they are not all selected; otherwise clear selection. */
  masterToggle() {
    this.isAllSelected()
      ? this.selection.clear()
      : this.items.forEach((row) => this.selection.select(row));

    this.setBulkAction();
  }

  /**
   * Change checkbox selection
   */
  changeSelection(item) {
    this.selection.toggle(item);
    this.setBulkAction();
  }

  /**
   * Show / hide bulk options
   */
  setBulkAction() {
    this.showBulkActions = this.selection.selected.length > 0;
  }

  /**
   * Perform bulk action
   */

  bulkAction(action) {
    const ids = [];
    this.isLoadingGeneral = true;
    this.selection.selected.forEach((row) => ids.push(row.id));

    const params = [action.id, ids];

    if (action.needs_confirmation || action.needs_reason) {
      const dialogRef = this.dialog.open(ConfirmActionModalComponent, {
        data: {
          action: action,
        },
      });

      dialogRef.afterClosed().subscribe((result) => {
        if (result && result !== undefined) {
          this.getService()
            ["updateStatusBulk"](...params, result)
            .subscribe(
              (data) => {
                this.getItems(1);
                this.isLoadingGeneral = false;
              },
              (error) => {
                if (error.error.errors) {
                  this.alertService.errors(error.error.errors);
                }
              }
            );
        }
        this.isLoadingGeneral = false;
      });
    } else {
      this.getService()
        ["updateStatusBulk"](...params, null)
        .subscribe((data) => {
          this.getItems(1);
          this.isLoadingGeneral = false;
        });
    }
  }

  /**
   * Change status for a single item
   */
  changeStatus(action, item) {
    const params = [action.id, [item.id]];

    if (action.needs_confirmation || action.needs_reason) {
      const dialogRef = this.dialog.open(ConfirmActionModalComponent, {
        data: {
          action: action,
        },
      });

      dialogRef.afterClosed().subscribe((result) => {
        if (result && result !== undefined) {
          this.getService()
            ["updateStatusBulk"](...params, result)
            .subscribe(
              (data) => {
                this.getItems();
              },
              (error) => {
                if (error.error.errors) {
                  this.alertService.errors(error.error.errors);
                }
              }
            );
        }
        this.isLoadingGeneral = false;
      });
    } else {
      this.getService()
        ["updateStatusBulk"](...params, null)
        .subscribe((data) => {
          this.getItems();
        });
    }
  }

  formatDataParam(data) {
    const formattedData = moment(new Date(data)).format("YYYY/MM/DD");
    return formattedData.split("/").join("-");
  }

  setFilteringDate(e) {
    if (e) {
      this.startDate = e.start_date;
      this.endDate = e.end_date;
    }
  }

  setInvoiceIssueDate(e, returnValue?) {
    if (returnValue === "clearFilterDate") {
      return e;
    } else {
      if (e.start_date && e.end_date) {
        if (returnValue) {
          return {
            invoice_issue_start_date: e.start_date,
            invoice_issue_end_date: e.end_date,
          };
        } else {
          this.getItems();
        }
      }
    }
  }

  setInvoiceDueDate(e, returnValue?) {
    if (returnValue === "clearFilterDate") {
      return e;
    } else {
      if (e.start_date && e.end_date) {
        if (returnValue) {
          return {
            invoice_due_start_date: e.start_date,
            invoice_due_end_date: e.end_date,
          };
        } else {
          this.getItems();
        }
      }
    }
  }

  setInvoicePaymentDate(e, returnValue?) {
    if (returnValue === "clearFilterDate") {
      return e;
    } else {
      if (e.start_date && e.end_date) {
        if (returnValue) {
          return {
            invoice_payment_start_date: e.start_date,
            invoice_payment_end_date: e.end_date,
          };
        } else {
          this.getItems();
        }
      }
    }
  }
}
